import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const tabsStyle = css`
  width: auto;
`;

export const paletteContainerStyle = css`
  width: 100%;
  margin: ${theme.spacing(1.5, 0)};
`;

export const customColorPickerContainerStyle = css`
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  margin: ${theme.spacing(1.5, 0)};

  .react-colorful {
    width: 100%;
    flex: 1;
  }

  .react-colorful__last-control {
    height: 10px;
  }

  .react-colorful__pointer {
    width: 15px;
    height: 15px;
  }
`;

export const hexColorPickerStyle = css`
  margin-top: -${theme.spacing(0.5)};
`;

export const hexInputContainerStyle = css`
  display: flex;
  gap: ${theme.spacing(1)};
  align-items: center;
  margin-bottom: -${theme.spacing(0.5)};
`;

export const textFieldStyle = css`
  padding-left: ${theme.spacing(1)};
  padding-right: 0;
  height: 28px;
  border: 1px solid ${theme.colors.neutral50};
`;

export const colorSwatchStyle = css`
  height: 16px;
  aspect-ratio: 1/1;
  border-radius: ${theme.borderRadius.small};
  border: 1px solid gray;
  background: var(--color-picker-swatch-background);
`;

export const eyeDropperButtonStyle = css`
  height: 100%;
  border-radius: ${theme.borderRadius.small};
  display: flex;
  padding: ${theme.spacing(0, 1)};
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.neutral50};
`;

export const articleDefaultWidthStyle = css`
  width: 200px;
`;

export const paletteContainerSquareStyle = css`
  aspect-ratio: 1/1;
`;

export const paletteGridStyle = css`
  display: grid;
  grid-gap: ${theme.spacing(1)};
  grid-auto-rows: max-content;
  width: 100%;
  grid-template-columns: var(--color-picker-palette-columns, repeat(6, 1fr));
`;

export const skeletonStyle = css`
  aspect-ratio: 1/1;
  display: block;
  border-radius: ${theme.borderRadius.full};
`;

export const paletteButtonStyle = css`
  aspect-ratio: 1/1;
  position: relative;

  &:focus {
    outline: none;
  }

  &:focus span::after {
    opacity: 1;
  }
`;

export const paletteButtonSpanStyle = css`
  display: block;
  border-radius: ${theme.borderRadius.full};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border: 1px solid ${theme.colors.neutral20};
  background: var(--color-picker-palette-button-background);

  &::after {
    content: '';
    height: calc(100% + 10px);
    width: calc(100% + 10px);
    display: block;
    background: white;
    z-index: -1;
    border: 2px solid ${theme.colors.primary50};
    border-radius: ${theme.borderRadius.full};
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 150ms ease-out;
  }
`;
